<template>
    <v-app id="inspire">
        <Navigation></Navigation>
        <AppBar :title="pageTitle"></AppBar>
        <v-content>

        </v-content>
    </v-app>
</template>
<script>
    export default {
        name: "Home",
        props: {
            pageTitle: {
                type: String,
                default: ''
            }
        },

        created(){
        },
    }
</script>